module.exports = __webpack_public_path__ + "static/media/bushra.0d285a5a.jpg";